import { Squad } from "../../types/squads";

export const getSquadsDetailsModel = (
  response: Squad | null
): Squad | null => response;
